import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n

import "@/styles/index.scss"; // global css
import App from "./App";
import store from "./store";
import router from "./router";
import "@/permission"; // permission control
import * as filters from "./utils/filter";
import "../mock"; // simulation data
import Mixin from "./mixins/editor_up";
Vue.mixin(Mixin);
Object.keys(filters).forEach(v => Vue.filter(v, filters[v]));
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
